"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleFallbackResolver = void 0;
const i18n_locale_utilities_1 = require("@amzn/i18n.locale-utilities");
const LOCALE_SEPARATOR = '-';
/**
 * This class is a helper class to resolve a locale fall-back chain.
 */
class LocaleFallbackResolver {
    /**
     * Creates the locale fallback chain based on the requested locale.
     * @param baseLocale the base locale from which the fallback chain starts.
     */
    static resolve(baseLocale) {
        if (!baseLocale) {
            return [baseLocale];
        }
        if (this.FALLBACK_CACHE && this.FALLBACK_CACHE.key === baseLocale) {
            return this.FALLBACK_CACHE.value;
        }
        const intlLocale = i18n_locale_utilities_1.LocaleUtil.getCanonicalLocale(new Intl.Locale(baseLocale));
        // Generate fallback chain of override configs similar to Java ResourceBundle:
        // https://docs.oracle.com/javase/8/docs/api/java/util/ResourceBundle.html#getBundle-java.lang.String-java.util.Locale-java.lang.ClassLoader-
        let fallbackLocales = [];
        // loop the complete base name
        let loc = intlLocale.baseName;
        let pos = loc.lastIndexOf(LOCALE_SEPARATOR);
        while (pos > 0) {
            fallbackLocales.push(loc);
            loc = loc.substring(0, pos);
            pos = loc.lastIndexOf(LOCALE_SEPARATOR);
        }
        // if script exists, remove it and re-loop
        // for example, locale `en-Latn-US` has script `Latn`, so this script is removed and fallback with locale `en-US`
        if (intlLocale.script) {
            // @ts-ignore
            const tmp = new Intl.Locale(intlLocale.baseName.replace(LOCALE_SEPARATOR + intlLocale.script, ''));
            loc = tmp.baseName;
            pos = loc.lastIndexOf(LOCALE_SEPARATOR);
            while (pos > 0) {
                fallbackLocales.push(loc);
                loc = loc.substring(0, pos);
                pos = loc.lastIndexOf(LOCALE_SEPARATOR);
            }
        }
        // capture the primary language subtag
        fallbackLocales.push(loc);
        fallbackLocales.push(undefined);
        if (baseLocale !== fallbackLocales[0]) {
            fallbackLocales = [baseLocale].concat(fallbackLocales);
        }
        this.FALLBACK_CACHE = {
            key: baseLocale,
            value: fallbackLocales
        };
        return fallbackLocales;
    }
    /**
     * Meant only for test purpose to clear up cache between test cases
     */
    static reset() {
        this.FALLBACK_CACHE = undefined;
    }
}
exports.LocaleFallbackResolver = LocaleFallbackResolver;
//# sourceMappingURL=locale-fallback-resolver.js.map